export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT ENTRANCE.2209f44a.jpg";